import styled, { css } from "styled-components";
import { Link as A } from "raviger";

const Link = styled(A)`
  color: ${(props) => props.theme.link.color};
  font-size: 1rem;

  ${(props) =>
    props.small &&
    css`
      font-size: 0.8rem;
    `}

  &:hover {
    color: ${(props) => props.theme.link.color};
  }
`;

export default Link;
